export default "__VITE_ASSET__22449d49__"